module.exports = __webpack_public_path__ + "img/channel-student2.2af3aecd.jpg";